import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';


@Injectable({
  providedIn: 'root'
})
export class NewsService {
  public Data = new BehaviorSubject(null)
  constructor(private _HttpClient:HttpClient) { }
  GetNews():Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/News/Get`);
  }
  GetNewsByid(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/News/GetById?id=${id}`);
  }
  GetNewsImage(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/NewsImage/Get?newsId=${id}`);
  }
  CreateNewsImage(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/NewsImage/Create`,data);
  }

  DeleteNewsImage(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/NewsImage/Delete?id=${id}`);
  }
  DeleteNews(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/News/Delete?id=${id}`);
  }

  CreateNews(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/News/Create`,data);
  }
  UpdateNews(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/News/Update`,data)
  }
}
